import React from "react";
import { Link } from "react-router-dom";
import "../../Styles/ClinicalPlannersConsultants.css";

function ClinicalPlannersConsultants({
  backgroundImage,
  onBookConsultation,
  onRequestCallback,
  primaryImage = "https://elumia.s3.ap-south-1.amazonaws.com/landing-page-elumia/Book+an+Initial+Consultation.webp",
  secondaryImage = "https://elumia.s3.ap-south-1.amazonaws.com/landing-page-elumia/Book+an+Initial+Consultation+1.webp",
  consultationUrl = "https://elumiamedstore.com/",
  imageSrc = "https://nexora-image.s3.ap-south-1.amazonaws.com/zoho+ads+page/last+image-new.webp",
}) {
  const backgroundStyle = {
    backgroundImage:
      'url("https://nexora-image.s3.ap-south-1.amazonaws.com/zoho+ads+page/Elumia+Hero+Banner-new-2.webp")',
  };

  const clinicServices = [
    { label: "Procurement", position: "top", icon: "procurement" },
    { label: "Recruitment", position: "left", icon: "recruitment" },
    { label: "Design & Fit-Out", position: "right", icon: "design" },
    { label: "Regulatory", position: "bottom-left", icon: "regulatory" },
    { label: "Digital", position: "bottom-right", icon: "digital" },
  ];

  function ServiceIcon({ name }) {
    const paths = {
      procurement: (
        <>
          <path d="M4 7.5 12 4l8 3.5v9L12 20l-8-3.5z" />
          <path d="M4 7.5 12 11l8-3.5M12 11v9M9 5.3l8 3.5v3.4l-3 1.3v-3.4" />
        </>
      ),
      recruitment: (
        <>
          <circle cx="12" cy="7.5" r="3.25" />
          <path d="M5.5 20v-2a6.5 6.5 0 0 1 13 0v2M3 20v-1.5a4 4 0 0 1 2-3.45M21 20v-1.5a4 4 0 0 0-2-3.45" />
        </>
      ),
      design: (
        <>
          <path d="m5 19 11.5-11.5 2.5 2.5L7.5 21H5zM14 5l2-2 5 5-2 2M4 5h7M4 8.5h4" />
        </>
      ),
      regulatory: (
        <>
          <rect x="5" y="5" width="14" height="16" rx="2" />
          <path d="M9 5V3h6v2M9 13l2.2 2.2L16 10.5" />
        </>
      ),
      digital: (
        <>
          <rect x="3" y="4" width="18" height="13" rx="2" />
          <path d="m9 8-3 2.5L9 13m6-5 3 2.5-3 2.5M8 21h8m-4-4v4" />
        </>
      ),
    };

    return (
      <svg
        aria-hidden="true"
        width="34"
        height="34"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {paths[name]}
      </svg>
    );
  }

  const services = [
    {
      title: "Medical Procurement Consulting",
      description:
        "Structured procurement planning, BOQ preparation and supplier coordination.",
      icon: "procurement",
      image:
        "https://elumia.s3.ap-south-1.amazonaws.com/landing-page-elumia/Medical+Procurement+Consulting.webp",
    },
    {
      title: "Clinic Architecture, Design & Fit-Out",
      description:
        "Space planning, healthcare interior design and fit-out coordination.",
      icon: "design",
      image:
        "https://elumia.s3.ap-south-1.amazonaws.com/landing-page-elumia/Clinic+Architecture+Design+Fit-Out.webp",
    },
    {
      title: "Website & Digital Marketing",
      description:
        "Digital foundation and patient acquisition channels before you open.",
      icon: "digital",
      image:
        "https://elumia.s3.ap-south-1.amazonaws.com/landing-page-elumia/Website++Digital+Marketing.webp",
    },
    {
      title: "DHA & MOHAP Approval Guidance",
      description:
        "Coordination and guidance through UAE healthcare regulatory requirements.",
      icon: "approval",
      image:
        "https://elumia.s3.ap-south-1.amazonaws.com/landing-page-elumia/DHA+MOHAP+Approval.webp",
    },
    {
      title: "Healthcare Recruitment & Training",
      description:
        "Build the right clinical and administrative team before launch.",
      icon: "recruitment",
      image:
        "https://elumia.s3.ap-south-1.amazonaws.com/landing-page-elumia/Healthcare+Recruitment+Training.webp",
    },
  ];

  function ServiceIcon({ type }) {
    const shapes = {
      procurement: (
        <>
          <path d="M4 8 12 4l8 4-8 4-8-4Z" />
          <path d="M4 8v9l8 4 8-4V8M12 12v9" />
        </>
      ),
      design: (
        <>
          <path d="M4 20h16M6 16l10-10 3 3-10 10H6v-3Z" />
          <path d="M13 9l3 3" />
        </>
      ),
      digital: (
        <>
          <rect x="3" y="4" width="18" height="14" rx="2" />
          <path d="M8 22h8m-4-4v4m-3-13-2 2 2 2m6-4 2 2-2 2" />
        </>
      ),
      approval: (
        <>
          <path d="M8 4h8l4 4v12H4V4h4Z" />
          <path d="M16 4v4h4m-12 5 2.5 2.5L16 10" />
        </>
      ),
      recruitment: (
        <>
          <circle cx="12" cy="7" r="3" />
          <path d="M5 20v-2a7 7 0 0 1 14 0v2M3 20v-1a5 5 0 0 1 3-4.6M21 20v-1a5 5 0 0 0-3-4.6" />
        </>
      ),
    };

    return (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        {shapes[type]}
      </svg>
    );
  }
  const planningItems = [
    { text: "Medical Consumables", icon: "box" },
    { text: "Medical Disposables", icon: "disposable" },
    { text: "Medical Equipment", icon: "equipment" },
    { text: "Emergency & Crash Cart Requirements", icon: "emergency" },
    { text: "Furniture & Clinical Essentials", icon: "furniture" },
    { text: "General Clinic Requirements", icon: "clinic" },
    { text: "Laboratory Requirements", icon: "laboratory" },
    { text: "Dental Requirements", icon: "dental" },
    { text: "Aesthetic & Dermatology Requirements", icon: "aesthetic" },
  ];

  const supportItems = [
    { text: "Requirement Planning", icon: "planning" },
    { text: "BOQ Preparation", icon: "document" },
    { text: "Product Selection", icon: "selection" },
    { text: "Supplier Coordination", icon: "suppliers" },
    { text: "Commercial Comparison", icon: "comparison" },
    { text: "Procurement", icon: "procurement" },
    { text: "Delivery Coordination", icon: "delivery" },
  ];

  function ProcurementIcon({ name }) {
    const icons = {
      box: (
        <>
          <path d="m4 8 8-4 8 4-8 4-8-4Z" />
          <path d="M4 8v9l8 4 8-4V8M12 12v9" />
        </>
      ),
      disposable: (
        <>
          <path d="M8 4h8v4H8zM7 8h10v12H7z" />
          <path d="M10 12h4m-2-2v4" />
        </>
      ),
      equipment: (
        <>
          <rect x="3" y="4" width="18" height="14" rx="2" />
          <path d="M7 11h2l2-3 2 6 2-3h2M8 22h8m-4-4v4" />
        </>
      ),
      emergency: (
        <>
          <rect x="4" y="7" width="16" height="14" rx="2" />
          <path d="M9 7V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2M12 10v8m-4-4h8" />
        </>
      ),
      furniture: (
        <>
          <path d="M5 12h14v6H5zM7 12V5h10v7M7 18v3m10-3v3" />
        </>
      ),
      aesthetic: (
        <>
          <path d="M12 3c2.8 4 5 7 5 10a5 5 0 0 1-10 0c0-3 2.2-6 5-10Z" />
          <path d="m19 3 .6 1.4L21 5l-1.4.6L19 7l-.6-1.4L17 5l1.4-.6L19 3Z" />
        </>
      ),
      laboratory: (
        <>
          <path d="M9 3h6m-5 0v7L5 19a2 2 0 0 0 1.7 3h10.6a2 2 0 0 0 1.7-3l-5-9V3" />
          <path d="M7 16h10" />
        </>
      ),
      dental: (
        <>
          <path d="M8 3c-2.5 0-4 2-4 5 0 3 1.5 5 2.5 8 .7 2 1.1 5 2.5 5 1.2 0 1.3-4 3-4s1.8 4 3 4c1.4 0 1.8-3 2.5-5C18.5 13 20 11 20 8c0-3-1.5-5-4-5-1.6 0-2.6 1-4 1S9.6 3 8 3Z" />
        </>
      ),
      clinic: (
        <>
          <path d="M4 21V8l8-5 8 5v13H4Z" />
          <path d="M10 21v-6h4v6M10 9h4m-2-2v4" />
        </>
      ),
      planning: (
        <>
          <rect x="5" y="5" width="14" height="16" rx="2" />
          <path d="M9 5V3h6v2M9 11h6m-6 4h6" />
        </>
      ),
      document: (
        <>
          <path d="M6 3h9l4 4v14H6V3Z" />
          <path d="M15 3v4h4M9 12h7m-7 4h7" />
        </>
      ),
      selection: (
        <>
          <rect x="4" y="4" width="16" height="16" rx="2" />
          <path d="m8 12 3 3 5-6" />
        </>
      ),
      suppliers: (
        <>
          <circle cx="8" cy="8" r="3" />
          <circle cx="17" cy="9" r="2.5" />
          <path d="M2 20v-2a6 6 0 0 1 12 0v2M15 15a5 5 0 0 1 7 4v1h-6" />
        </>
      ),
      comparison: (
        <>
          <path d="M12 3v18M5 7h14M5 7l-3 6h6L5 7Zm14 0-3 6h6l-3-6ZM8 21h8" />
        </>
      ),
      procurement: (
        <>
          <path d="M5 8h14l-1 13H6L5 8Z" />
          <path d="M9 9V6a3 3 0 0 1 6 0v3" />
        </>
      ),
      delivery: (
        <>
          <path d="M3 7h11v11H3V7Zm11 4h4l3 3v4h-7v-7Z" />
          <circle cx="7" cy="19" r="2" />
          <circle cx="18" cy="19" r="2" />
        </>
      ),
    };

    return (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        {icons[name]}
      </svg>
    );
  }

  function ImagePlaceholder() {
    return (
      <div className="medical-procurement__placeholder" aria-hidden="true">
        <svg viewBox="0 0 80 80" fill="none">
          <rect x="12" y="15" width="56" height="50" rx="5" />
          <circle cx="31" cy="32" r="5" />
          <path d="m15 58 17-17 12 12 9-9 12 14" />
        </svg>
      </div>
    );
  }

  const servicesone = [
    { title: "linic Space Planning", icon: "space" },
    { title: "Healthcare Interior Design", icon: "interior" },
    { title: "Architectural Coordination", icon: "architecture" },
    { title: "MEP Coordination", icon: "mep" },
    { title: "Reception & Patient Areas", icon: "reception" },
    { title: "Consultation Rooms", icon: "consultation" },
    { title: "Treatment Rooms", icon: "treatment" },
    { title: "Pharmacy/Laboratory Areas", icon: "laboratory" },
    { title: "Medical Furniture Planning", icon: "furniture" },
    { title: "Fit-Out Coordination", icon: "fitout" },
    { title: "Signage & Branding", icon: "signage" },
    { title: "Equipment Placement Planning", icon: "equipment" },
  ];

  function ArchitectureIcon({ name }) {
    const shapes = {
      space: (
        <>
          <rect x="3" y="3" width="18" height="18" rx="2" />
          <path d="M10 3v10H3m7 0h11m-6 0v8" />
        </>
      ),
      interior: (
        <>
          <path d="M5 20h14M7 20v-7h10v7M9 13V8h6v5" />
          <path d="M12 3v3m-3 0h6" />
        </>
      ),
      architecture: (
        <>
          <path d="m3 20 9-17 9 17H3Z" />
          <path d="M8 20v-6h8v6M12 3v4" />
        </>
      ),
      mep: (
        <>
          <path d="M12 2 5 13h6l-1 9 9-12h-6l1-8Z" />
        </>
      ),
      reception: (
        <>
          <path d="M3 20h18M5 15h14v5H5z" />
          <circle cx="12" cy="6" r="2.5" />
          <path d="M8 13a4 4 0 0 1 8 0" />
        </>
      ),
      consultation: (
        <>
          <path d="M4 5h16v11H9l-5 4V5Z" />
          <path d="M9 10h6m-3-3v6" />
        </>
      ),
      treatment: (
        <>
          <path d="M3 17h18M5 17v4m14-4v4M6 12h14v5H6z" />
          <path d="M10 4h4m-2-2v4M6 12V8h5v4" />
        </>
      ),
      laboratory: (
        <>
          <path d="M9 3h6m-5 0v7l-5 9a2 2 0 0 0 1.7 3h10.6a2 2 0 0 0 1.7-3l-5-9V3" />
          <path d="M7 16h10" />
        </>
      ),
      furniture: (
        <>
          <path d="M5 12h14v6H5zM7 12V5h10v7M7 18v3m10-3v3" />
        </>
      ),
      fitout: (
        <>
          <path d="M14 5a5 5 0 0 0 5 5l-9 9a3 3 0 0 1-4-4l9-9a5 5 0 0 0-1-1Z" />
          <path d="m5 18 1 1" />
        </>
      ),
      signage: (
        <>
          <path d="M4 5h16v11H4zM12 16v5m-5 0h10" />
          <path d="M8 11h8m-5-3h2" />
        </>
      ),
      equipment: (
        <>
          <rect x="3" y="4" width="18" height="14" rx="2" />
          <path d="M8 22h8m-4-4v4M7 11h2l2-3 2 6 2-3h2" />
        </>
      ),
    };

    return (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        {shapes[name]}
      </svg>
    );
  }

  const websiteItems = [
    "Clinic Website Development",
    "Doctor Profile Pages",
    "Service & Specialty Pages",
    "Appointment Enquiry Integration",
    "WhatsApp Integration",
    "Landing Pages",
    "Website Maintenance",
    "SEO Foundations",
  ];

  const marketingItems = [
    "Social Media Setup",
    "Content Strategy",
    "Meta Advertising",
    "Google Advertising",
    "Lead Generation Campaigns",
    "Clinic Launch Campaigns",
    "Doctor Promotion Campaigns",
    "Local Area Marketing",
    "Performance Reporting",
  ];

  const journey = [
    "Awareness",
    "Enquiries",
    "Appointments",
    "Patients",
    "Retention",
  ];

  function GroupIcon({ type }) {
    if (type === "website") {
      return (
        <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <rect x="3" y="4" width="18" height="16" rx="2" />
          <path d="M3 9h18M7 6.5h.01M10 6.5h.01M7 13h5m-5 3h9" />
        </svg>
      );
    }

    return (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M4 10v4h4l10 5V5L8 10H4Z" />
        <path d="m8 14 2 6h3l-2-5M20 9a4 4 0 0 1 0 6" />
      </svg>
    );
  }
  function SectionIcon({ type }) {
    return (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        {type === "website" ? (
          <>
            <rect x="3" y="4" width="18" height="16" rx="2" />
            <path d="M3 9h18M7 6.5h.01M10 6.5h.01M7 13h5m-5 3h9" />
          </>
        ) : (
          <>
            <path d="M4 10v4h4l10 5V5L8 10H4Z" />
            <path d="m8 14 2 6h3l-2-5M20 9a4 4 0 0 1 0 6" />
          </>
        )}
      </svg>
    );
  }

  function FeaturePanel({ title, type, items }) {
    return (
      <div className={`clinic-digital__panel clinic-digital__panel--${type}`}>
        <div className="clinic-digital__panel-heading">
          <span className="clinic-digital__panel-icon">
            <SectionIcon type={type} />
          </span>
          <h3>{title}</h3>
        </div>

        <ul className="clinic-digital__features">
          {items.map((item) => (
            <li key={item}>
              <span className="clinic-digital__feature-mark" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none">
                  <path d="m5 12 4 4L19 6" />
                </svg>
              </span>
              <span>{item}</span>
            </li>
          ))}
        </ul>
      </div>
    );
  }

  const guidanceItems = [
    { title: "Initial Requirement Assessment", icon: "assessment" },
    { title: "Documentation Checklist", icon: "checklist" },
    { title: "Facility Requirement Guidance", icon: "facility" },
    { title: "Application Process Coordination", icon: "application" },
    { title: "Professional Licensing Coordination", icon: "licensing" },
    { title: "Medical Equipment Requirement Planning", icon: "equipment" },
    { title: "Inspection Preparation Support", icon: "inspection" },
    { title: "Regulatory Documentation Coordination", icon: "documents" },
    { title: "Renewal & Compliance Support", icon: "renewal" },
  ];

  function GuidanceIcon({ name }) {
    const shapes = {
      assessment: (
        <>
          <rect x="5" y="5" width="14" height="16" rx="2" />
          <path d="M9 5V3h6v2m-6 8 2 2 4-4" />
        </>
      ),
      checklist: (
        <>
          <path d="M6 3h9l4 4v14H6V3Z" />
          <path d="M15 3v4h4M9 12l1.5 1.5L13 11m-4 6h7" />
        </>
      ),
      facility: (
        <>
          <path d="M4 21V8l8-5 8 5v13H4Z" />
          <path d="M10 21v-6h4v6M9 10h6m-3-3v6" />
        </>
      ),
      application: (
        <>
          <path d="M6 3h9l4 4v14H6V3Z" />
          <path d="M15 3v4h4M9 12h7m-7 4h4" />
          <path d="m15 17 1.5 1.5L20 15" />
        </>
      ),
      licensing: (
        <>
          <rect x="3" y="5" width="18" height="15" rx="2" />
          <circle cx="9" cy="11" r="2" />
          <path d="M6 17c.5-1.5 1.5-2 3-2s2.5.5 3 2m3-7h3m-3 4h3" />
        </>
      ),
      equipment: (
        <>
          <rect x="3" y="4" width="18" height="14" rx="2" />
          <path d="M7 11h2l2-3 2 6 2-3h2M8 22h8m-4-4v4" />
        </>
      ),
      inspection: (
        <>
          <circle cx="10.5" cy="10.5" r="6.5" />
          <path d="m15.5 15.5 5 5m-14-10 2.5 2.5 4-4" />
        </>
      ),
      documents: (
        <>
          <path d="M8 3h9l4 4v13H8V3Z" />
          <path d="M17 3v4h4M4 7v14h12m-4-9h5m-5 4h5" />
        </>
      ),
      renewal: (
        <>
          <path d="M20 11a8 8 0 0 0-14.5-4.5L3 9" />
          <path d="M3 4v5h5M4 13a8 8 0 0 0 14.5 4.5L21 15" />
          <path d="M16 15h5v5" />
        </>
      ),
    };

    return (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        {shapes[name]}
      </svg>
    );
  }

  const recruitmentItems = [
    "Doctors",
    "Nurses",
    "Pharmacists",
    "Receptionists",
    "Clinic Managers",
    "Medical Representatives",
    "Business Development Staff",
    "Customer Service Staff",
    "Administrative Staff",
  ];

  const trainingItems = [
    "Front Desk & Patient Experience",
    "Telephone Etiquette",
    "Sales & Business Development",
    "Customer Service",
    "Clinic Operations",
    "Inventory Management",
    "Procurement Processes",
    "Professional Communication",
    "Team Leadership",
    "Product Knowledge",
  ];

  function GroupIcon({ type }) {
    return (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        {type === "recruitment" ? (
          <>
            <circle cx="12" cy="7" r="3" />
            <path d="M5 20v-2a7 7 0 0 1 14 0v2" />
            <path d="M3 20v-1a5 5 0 0 1 3-4.6M21 20v-1a5 5 0 0 0-3-4.6" />
          </>
        ) : (
          <>
            <path d="m2 9 10-5 10 5-10 5L2 9Z" />
            <path d="M6 11v5c0 2 3 4 6 4s6-2 6-4v-5M22 9v6" />
          </>
        )}
      </svg>
    );
  }

  function ContentGroup({ title, type, items }) {
    return (
      <div className={`healthcare-team__group healthcare-team__group--${type}`}>
        <div className="healthcare-team__group-heading">
          <span className="healthcare-team__heading-icon">
            <GroupIcon type={type} />
          </span>
          <h3>{title}</h3>
        </div>

        <ul className="healthcare-team__list">
          {items.map((item) => (
            <li key={item}>
              <span className="healthcare-team__list-dot" aria-hidden="true" />
              <span>{item}</span>
            </li>
          ))}
        </ul>
      </div>
    );
  }

  const journeyStages = [
    {
      title: "Concept & Feasibility",
      description:
        "Understand the clinic concept, specialties, location, operational requirements and budget.",
      image:
        "https://elumia.s3.ap-south-1.amazonaws.com/landing-page-elumia/Concept++Feasibility.webp",
    },
    {
      title: "Regulatory Roadmap",
      description:
        "Identify applicable licensing, documentation and facility requirements.",
      image:
        "https://elumia.s3.ap-south-1.amazonaws.com/landing-page-elumia/Regulatory+Roadmap.webp",
    },
    {
      title: "Design & Fit-Out",
      description:
        "Coordinate space planning, design, technical requirements and fit-out.",
      image:
        "https://elumia.s3.ap-south-1.amazonaws.com/landing-page-elumia/Design+%26+Fit-Out.webp",
    },
    {
      title: "Procurement",
      description:
        "Prepare requirements and procure equipment, consumables and essentials.",
      image:
        "https://elumia.s3.ap-south-1.amazonaws.com/landing-page-elumia/Procurement.webp",
    },
    {
      title: "Recruitment",
      description:
        "Support the development of the clinical and administrative team.",
      image:
        "https://elumia.s3.ap-south-1.amazonaws.com/landing-page-elumia/Recruitment.webp",
    },
    {
      title: "Digital Launch",
      description:
        "Develop the website, digital presence and patient acquisition campaigns.",
      image:
        "https://elumia.s3.ap-south-1.amazonaws.com/landing-page-elumia/Digital+Launch.webp",
    },
    {
      title: "Training & Readiness",
      description:
        "Prepare teams, workflows and operational processes before launch.",
      image:
        "https://elumia.s3.ap-south-1.amazonaws.com/landing-page-elumia/Training++Readiness.webp",
    },
    {
      title: "Ongoing Support",
      description:
        "Continue supporting procurement, inventory, marketing and growth",
      image:
        "https://elumia.s3.ap-south-1.amazonaws.com/landing-page-elumia/Ongoing+Support.webp",
    },
  ];

  function JourneyIcon({ type }) {
    const commonProps = {
      width: 28,
      height: 28,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 1.8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      "aria-hidden": true,
    };

    switch (type) {
      case "concept":
        return (
          <svg {...commonProps}>
            <path d="M9 18h6M10 22h4M8.1 14.5A7 7 0 1 1 15.9 14.5c-.9.7-1.4 1.6-1.6 2.5h-4.6c-.2-.9-.7-1.8-1.6-2.5Z" />
          </svg>
        );

      case "regulatory":
        return (
          <svg {...commonProps}>
            <path d="M8 3h8l3 3v15H5V3h3Z" />
            <path d="M14 3v4h5M8 12h8M8 16h5" />
          </svg>
        );

      case "design":
        return (
          <svg {...commonProps}>
            <path d="M3 21h18M5 21V8l7-5 7 5v13M9 21v-7h6v7M9 10h.01M15 10h.01" />
          </svg>
        );

      case "procurement":
        return (
          <svg {...commonProps}>
            <path d="M3 7h18v14H3V7ZM3 11h18M8 7V4h8v3M12 11v10" />
          </svg>
        );

      case "recruitment":
        return (
          <svg {...commonProps}>
            <circle cx="9" cy="8" r="3" />
            <path d="M3 21v-2a6 6 0 0 1 12 0v2H3ZM16 5a3 3 0 0 1 0 6M18 15a5 5 0 0 1 3 4v2h-3" />
          </svg>
        );

      case "digital":
        return (
          <svg {...commonProps}>
            <rect x="3" y="4" width="18" height="14" rx="2" />
            <path d="M8 22h8M12 18v4M3 8h18M8 12l2 2 4-4" />
          </svg>
        );

      case "training":
        return (
          <svg {...commonProps}>
            <path d="m2 8 10-5 10 5-10 5L2 8ZM6 10v6c0 2 3 4 6 4s6-2 6-4v-6M22 8v7" />
          </svg>
        );

      case "support":
        return (
          <svg {...commonProps}>
            <path d="M4 14a8 8 0 0 1 14-5M20 10a8 8 0 0 1-14 5" />
            <path d="M18 4v5h-5M6 20v-5h5" />
          </svg>
        );

      default:
        return null;
    }
  }

  const reasons = [
    "Healthcare-focused approach",
    "Procurement expertise",
    "Medical supply capabilities",
    "UAE market understanding",
    "Network of specialized partners",
    "Single point of coordination",
    "Support from planning through operations",
    "Continued support after clinic launch",
  ];

  function CheckIcon() {
    return (
      <svg
        width="17"
        height="17"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="m5 12 4.5 4.5L19 7" />
      </svg>
    );
  }

  const audiences = [
    {
      title: "New Clinic Investors",
      description: "Planning their first healthcare facility in the UAE.",
      icon: "investor",
    },
    {
      title: "Existing Clinics",
      description: "Looking to renovate, expand or add new specialties.",
      icon: "clinic",
    },
    {
      title: "Doctors & Healthcare Entrepreneurs",
      description: "Planning to establish their own practice.",
      icon: "doctor",
    },
    {
      title: "Healthcare Groups",
      description: "Opening additional branches or expanding operations.",
      icon: "group",
    },
    {
      title: "International Healthcare Investors",
      description:
        "Exploring opportunities to establish healthcare operations in the UAE.",
      icon: "international",
    },
  ];

  function AudienceIcon({ type }) {
    const svgProps = {
      width: 30,
      height: 30,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 1.8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      "aria-hidden": true,
    };

    switch (type) {
      case "investor":
        return (
          <svg {...svgProps}>
            <path d="M3 20h18M5 16v4M10 12v8M15 9v11M20 5v15" />
            <path d="m4 11 5-4 4 2 6-5M16 4h3v3" />
          </svg>
        );

      case "clinic":
        return (
          <svg {...svgProps}>
            <path d="M4 21V6h16v15M2 21h20M9 21v-5h6v5" />
            <path d="M12 8v5M9.5 10.5h5M7 6V3h10v3" />
          </svg>
        );

      case "doctor":
        return (
          <svg {...svgProps}>
            <path d="M6 3v6a4 4 0 0 0 8 0V3M4 3h4M12 3h4" />
            <path d="M10 13v2a5 5 0 0 0 10 0v-2" />
            <circle cx="20" cy="11" r="2" />
          </svg>
        );

      case "group":
        return (
          <svg {...svgProps}>
            <path d="M2 21h20M4 21V9h7v12M13 21V4h7v17" />
            <path d="M6.5 12h2M6.5 16h2M15.5 8h2M15.5 12h2M15.5 16h2" />
          </svg>
        );

      case "international":
        return (
          <svg {...svgProps}>
            <circle cx="12" cy="12" r="9" />
            <path d="M3 12h18M12 3a15 15 0 0 1 0 18M12 3a15 15 0 0 0 0 18" />
            <path d="M5 7h14M5 17h14" />
          </svg>
        );

      default:
        return null;
    }
  }

  const consultationDetails = [
    "Clinic Type",
    "Proposed Location",
    "Specialties",
    "Approximate Size",
    "Expected Opening Date",
    "Services Required",
    "Estimated Budget",
  ];

  function ImagePlaceholder({ className, image, alt }) {
    return (
      <div className={`start-journey__image ${className}`}>
        {image ? (
          <img src={image} alt={alt} />
        ) : (
          <div className="start-journey__image-placeholder">
            <svg
              width="42"
              height="42"
              viewBox="0 0 48 48"
              fill="none"
              aria-hidden="true"
            >
              <rect
                x="5"
                y="8"
                width="38"
                height="32"
                rx="5"
                stroke="currentColor"
                strokeWidth="2"
              />
              <circle
                cx="17"
                cy="19"
                r="3"
                stroke="currentColor"
                strokeWidth="2"
              />
              <path
                d="m8 35 11-10 7 6 6-5 8 9"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span>Image Placeholder</span>
          </div>
        )}
      </div>
    );
  }

  return (
    <main className="clinical-planners-page">
      {/* hero section */}

     <section
  className="elumia-clinic-hero"
  aria-labelledby="elumia-clinic-hero-title"
  style={backgroundStyle}
>
  <img
    className="elumia-clinic-hero__desktop-logo"
    src="https://nexora-image.s3.ap-south-1.amazonaws.com/zoho+ads+page/Elumia+logos.webp"
    alt="Elumia"
  />

  <img
    className="elumia-clinic-hero__mobile-image"
    src="https://elumia.s3.ap-south-1.amazonaws.com/landing-page-elumia/elumia+mob+version.webp"
    alt=""
    aria-hidden="true"
  />

  <div className="elumia-clinic-hero__inner">
    <div className="elumia-clinic-hero__content">
      <span className="elumia-clinic-hero__accent" aria-hidden="true" />

      <h1 id="elumia-clinic-hero-title">CLINIC CONSULTANTS</h1>

      <span className="elumia-clinic-hero__byline">
        B Y &nbsp; E L U M I A
      </span>

      <h2>From Clinic Concept to Successful Operations</h2>

      <div className="elumia-clinic-hero__actions">
        <button
          className="elumia-clinic-hero__button elumia-clinic-hero__button--primary"
          type="button"
          onClick={onBookConsultation}
        >
          BOOK A CONSULTATION
        </button>

        <button
          className="elumia-clinic-hero__button elumia-clinic-hero__button--secondary"
          type="button"
          onClick={onRequestCallback}
        >
          REQUEST A CALL BACK
        </button>
      </div>
    </div>
  </div>
</section>

      {/* Planning a new clinic */}

      <section
        className="clinical-intro"
        aria-labelledby="clinical-intro-title"
      >
        <div className="clinical-intro__container">
          <div className="clinical-intro__copy">
            <span className="clinical-intro__accent" aria-hidden="true" />

            <h2 id="clinical-intro-title">
              <span>Planning a new clinic?</span>
              <span>Expanding an existing healthcare facility?</span>
            </h2>

            <div className="clinical-intro__cards">
              <div className="clinical-intro__card clinical-intro__card--gold">
                <p>
                  Elumia Clinic Consultants brings together procurement, clinic
                  setup coordination, digital solutions, regulatory guidance,
                  recruitment and training under one platform.
                </p>
              </div>

              <div className="clinical-intro__card clinical-intro__card--blue">
                <p>
                  Instead of coordinating with multiple vendors and service
                  providers, healthcare entrepreneurs and clinic operators can
                  work with Elumia as a single point of coordination throughout
                  their clinic journey
                </p>
              </div>
            </div>
          </div>

          <div
            className="clinical-network"
            role="group"
            aria-label="Elumia clinic services"
          >
            <img
              className="clinical-network__image"
              src="https://nexora-image.s3.ap-south-1.amazonaws.com/zoho+ads+page/2nd+image-new.webp"
              alt="Elumia clinic services including procurement, recruitment, design and fit-out, regulatory guidance, and digital support"
              loading="lazy"
            />
          </div>
        </div>
      </section>

      <section
        className="clinical-services-section"
        aria-labelledby="clinical-services-title"
      >
        <div className="clinical-services-section__container">
          <p className="clinical-services-section__eyebrow">OUR SERVICES</p>

          <h2 id="clinical-services-title">
            Five Coordinated Solutions, One Platform
          </h2>

          <div className="clinical-services-section__grid">
            {services.map((service) => (
              <article className="clinical-service-card" key={service.title}>
                <img
                  className="clinical-service-card__image"
                  src={service.image}
                  alt={service.title}
                  loading="lazy"
                />

                <div className="clinical-service-card__heading">
                  <span className="clinical-service-card__icon">
                    <ServiceIcon type={service.icon} />
                  </span>

                  <h3>{service.title}</h3>
                </div>

                <p className="clinical-service-card__description">
                  {service.description}
                </p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section
        className="medical-procurement"
        aria-labelledby="medical-procurement-title"
      >
        <div className="medical-procurement__container">
          <header className="medical-procurement__header">
            <p className="medical-procurement__eyebrow">
              01 | MEDICAL PROCUREMENT CONSULTING
            </p>

            <h2 id="medical-procurement-title">
              Smarter Procurement. Better Planning. Controlled Costs
            </h2>
          </header>

          <div className="medical-procurement__row">
            <div className="medical-procurement__content">
              <h3>Structured procurement planning for</h3>

              <ul className="medical-procurement__planning-list">
                {planningItems.map((item) => (
                  <li key={item.text}>
                    <span className="medical-procurement__item-icon">
                      <ProcurementIcon name={item.icon} />
                    </span>
                    <span className="medical-procurement__item-text">
                      {item.text}
                    </span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="medical-procurement__visual medical-procurement__visual--planning">
              {/* <ImagePlaceholder /> */}

              {/* Replace ImagePlaceholder with your image later: */}
              <img
                className="medical-procurement__image"
                src="https://nexora-image.s3.ap-south-1.amazonaws.com/zoho+ads+page/Structured+procurement+planning+for-new.webp"
                alt="Medical procurement planning"
              />
            </div>
          </div>

          <div className="medical-procurement__row medical-procurement__row--reverse">
            <div className="medical-procurement__visual medical-procurement__visual--support">
              {/* <ImagePlaceholder /> */}

              {/* Replace ImagePlaceholder with your image later: */}
              <img
                className="medical-procurement__image"
                src="https://elumia.s3.ap-south-1.amazonaws.com/landing-page-elumia/Our+Procurement+Support.webp"
                alt="Clinic procurement support"
              />
            </div>

            <div className="medical-procurement__content">
              <h3>Our Procurement Support</h3>

              <ul className="medical-procurement__support-list">
                {supportItems.map((item) => (
                  <li key={item.text}>
                    <span className="medical-procurement__item-icon">
                      <ProcurementIcon name={item.icon} />
                    </span>
                    <span className="medical-procurement__item-text">
                      {item.text}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <p className="medical-procurement__objective">
            Our objective is to help clinics procure the right products, in the
            right quantities, at the right time — while maintaining visibility
            over budgets and operational requirements
          </p>
        </div>
      </section>

     <section
  className="clinic-architecture"
  aria-labelledby="clinic-architecture-title"
>
  <div className="clinic-architecture__container">
    <header className="clinic-architecture__header">
      <p className="clinic-architecture__eyebrow">
        02 | CLINIC ARCHITECTURE, INTERIOR DESIGN &amp; FIT -OUT
      </p>

      <h2 id="clinic-architecture-title">
        Build a Clinic Designed for Healthcare Operations
      </h2>

      <span
        className="clinic-architecture__header-line"
        aria-hidden="true"
      />

      <p className="clinic-architecture__description">
        Through qualified specialist partners, Elumia can coordinate
        clinic planning and fit-out requirements, including:
      </p>
    </header>

    <div className="clinic-architecture__wheel">
      <div
        className="clinic-architecture__orbit-track"
        aria-hidden="true"
      />

      <div className="clinic-architecture__center">
        <img
          className="clinic-architecture__center-image"
          src="https://nexora-image.s3.ap-south-1.amazonaws.com/zoho+ads+page/round+image-new.webp"
          alt="Modern clinic interior"
          loading="lazy"
        />
      </div>

      <ul className="clinic-architecture__orbit">
        {servicesone.map((service, index) => (
          <li
            className="clinic-architecture__orbit-item"
            key={service.title}
            style={{
              "--item-angle": `${(index * 360) / servicesone.length}deg`,
            }}
          >
            <div className="clinic-architecture__card">
              <span
                className="clinic-architecture__icon"
                aria-hidden="true"
              >
                <ArchitectureIcon name={service.icon} />
              </span>

              <h3>{service.title}</h3>
            </div>
          </li>
        ))}
      </ul>
    </div>

    <p className="clinic-architecture__approach">
      Our approach connects design decisions with actual clinical
      workflow and equipment requirements.
    </p>

    <ul className="clinic-architecture__service-list">
      {servicesone.map((service) => (
        <li key={service.title}>
          <span
            className="clinic-architecture__service-icon"
            aria-hidden="true"
          >
            <ArchitectureIcon name={service.icon} />
          </span>
          <span className="clinic-architecture__service-title">
            {service.title}
          </span>
        </li>
      ))}
    </ul>
  </div>
</section>

      <section
        className="clinic-digital"
        aria-labelledby="clinic-digital-title"
      >
        <div className="clinic-digital__container">
          <header className="clinic-digital__header">
            <p className="clinic-digital__eyebrow">
              03 | WEBSITE DEVELOPMENT &amp; DIGITAL MARKETING
            </p>

            <h2 id="clinic-digital-title">
              Build Your Clinic&apos;s Digital Presence Before Opening the Doors
            </h2>
          </header>

          {/* One image for the complete section */}
          <div
            className="clinic-digital__image-area"
            role="img"
            aria-label="Clinic digital presence image placeholder"
          >
            {/* <span className="clinic-digital__placeholder" aria-hidden="true">
              <svg viewBox="0 0 80 80" fill="none">
                <rect x="12" y="15" width="56" height="50" rx="5" />
                <circle cx="31" cy="32" r="5" />
                <path d="m15 58 17-17 12 12 9-9 12 14" />
              </svg>
            </span> */}

            {/* Replace the placeholder with one image later: */}
            <img
              className="clinic-digital__image"
              src="https://elumia.s3.ap-south-1.amazonaws.com/landing-page-elumia/Clinic's+Digital+Presence.webp"
              alt="Clinic team planning its website and digital marketing"
            />
          </div>

          <div className="clinic-digital__panels">
            <FeaturePanel
              title="Website & Technology"
              type="website"
              items={websiteItems}
            />

            <FeaturePanel
              title="Digital Marketing"
              type="marketing"
              items={marketingItems}
            />
          </div>

          <ol className="clinic-digital__journey">
            {journey.map((step) => (
              <li key={step}>{step}</li>
            ))}
          </ol>
        </div>
      </section>

    <section
  className="regulatory-guidance"
  aria-labelledby="regulatory-guidance-title"
>
  <div className="regulatory-guidance__container">
    <header className="regulatory-guidance__header">
      <p className="regulatory-guidance__eyebrow">
        04 | DHA &amp; MOHAP APPROVAL GUIDANCE
      </p>

      <h2 id="regulatory-guidance-title">
        Navigate Healthcare Regulatory Requirements with Better Coordination
      </h2>

      <p className="regulatory-guidance__description">
        Elumia can provide coordination and guidance for clinic establishment
        and healthcare regulatory processes, including requirements involving
        relevant UAE healthcare authorities.
      </p>
    </header>

    <ul className="regulatory-guidance__grid">
      {guidanceItems.map((item, index) => (
        <li
          className="regulatory-guidance__card"
          key={item.title}
          style={{ "--card-index": index }}
        >
          <div className="regulatory-guidance__card-content">
            <span className="regulatory-guidance__icon" aria-hidden="true">
              <GuidanceIcon name={item.icon} />
            </span>

            <h3>{item.title}</h3>
          </div>
        </li>
      ))}
    </ul>

    <p className="regulatory-guidance__note">
      Regulatory approvals remain subject to the requirements, review and
      decisions of the applicable authorities.
    </p>
  </div>
</section>

    <section
      className="healthcare-team"
      aria-labelledby="healthcare-team-title"
    >
      <div className="healthcare-team__container">
        <header className="healthcare-team__header">
          <p className="healthcare-team__eyebrow">
            05 | HEALTHCARE RECRUITMENT &amp; TRAINING
          </p>

          <h2 id="healthcare-team-title">
            Build the Right Team Before You Launch
          </h2>

          <p className="healthcare-team__intro">
            A clinic&apos;s success depends on more than infrastructure and
            equipment. It depends on people.
          </p>
        </header>

        <div className="healthcare-team__layout">
          <div className="healthcare-team__visual">
            <img
              className="healthcare-team__image"
              src="https://elumia.s3.ap-south-1.amazonaws.com/landing-page-elumia/Build+the+Right+Team+Before+You+Launch.webp"
              alt="Healthcare professionals working together in a clinic"
              loading="lazy"
            />
          </div>

          <div className="healthcare-team__panels">
            <div className="healthcare-team__panel healthcare-team__panel--recruitment">
              <div className="healthcare-team__panel-heading">
                <span
                  className="healthcare-team__heading-icon"
                  aria-hidden="true"
                >
                  <svg viewBox="0 0 32 32" fill="none">
                    <circle cx="16" cy="10" r="4" />
                    <path d="M8 25v-3a8 8 0 0 1 16 0v3" />
                    <circle cx="5.5" cy="13" r="2.5" />
                    <path d="M2 24v-2a5 5 0 0 1 5-5" />
                    <circle cx="26.5" cy="13" r="2.5" />
                    <path d="M30 24v-2a5 5 0 0 0-5-5" />
                  </svg>
                </span>

                <h3>Recruitment Support</h3>
              </div>

              <ul className="healthcare-team__items healthcare-team__items--recruitment">
                {recruitmentItems.map((item) => (
                  <li className="healthcare-team__item" key={item}>
                    <span
                      className="healthcare-team__item-mark"
                      aria-hidden="true"
                    >
                      ✓
                    </span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="healthcare-team__panel healthcare-team__panel--training">
              <div className="healthcare-team__panel-heading">
                <span
                  className="healthcare-team__heading-icon"
                  aria-hidden="true"
                >
                  <svg viewBox="0 0 32 32" fill="none">
                    <path d="m3 12 13-6 13 6-13 6-13-6Z" />
                    <path d="M9 15v7c4 4 10 4 14 0v-7" />
                    <path d="M29 12v9" />
                  </svg>
                </span>

                <h3>Training Programs</h3>
              </div>

              <ul className="healthcare-team__items healthcare-team__items--training">
                {trainingItems.map((item) => (
                  <li className="healthcare-team__item" key={item}>
                    <span
                      className="healthcare-team__item-mark"
                      aria-hidden="true"
                    >
                      ✓
                    </span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

      <section
        className="elumia-journey"
        aria-labelledby="elumia-journey-title"
      >
        <div className="elumia-journey__container">
          <header className="elumia-journey__header">
            <p className="elumia-journey__eyebrow">THE ELUMIA CLINIC JOURNEY</p>

            <h2 id="elumia-journey-title" className="elumia-journey__heading">
              Eight Stages, One Coordinated Partner
            </h2>
          </header>

          <div className="elumia-journey__grid">
            {journeyStages.map((stage) => (
              <article className="elumia-journey__card" key={stage.title}>
                <div className="elumia-journey__card-content">
                  <div className="elumia-journey__image">
                    {stage.image ? (
                      <img src={stage.image} alt="" loading="lazy" />
                    ) : (
                      <div className="elumia-journey__placeholder">
                        Image Placeholder
                      </div>
                    )}
                  </div>

                  <div className="elumia-journey__text">
                    <h3 className="elumia-journey__card-title">
                      {stage.title}
                    </h3>

                    <p className="elumia-journey__description">
                      {stage.description}
                    </p>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="why-elumia" aria-labelledby="why-elumia-title">
        <div className="why-elumia__container">
          <div className="why-elumia__content">
            <p className="why-elumia__eyebrow">WHY ELUMIA?</p>

            <h2 id="why-elumia-title" className="why-elumia__title">
              One Partner. Multiple Solutions.
            </h2>

            <p className="why-elumia__description">
              Instead of working independently with a medical supplier, fit-out
              contractor, marketing agency, recruitment company and other
              service providers, Elumia provides a coordinated platform for
              clinic owners
            </p>

            <div className="why-elumia__cards">
              {reasons.map((reason) => (
                <div className="why-elumia__card" key={reason}>
                  <span className="why-elumia__check">
                    <CheckIcon />
                  </span>

                  <h3 className="why-elumia__card-title">{reason}</h3>
                </div>
              ))}
            </div>
          </div>

          <div
            className="why-elumia__image"
            role="img"
            aria-label="Placeholder for Why Elumia section image"
          >
            <div className="why-elumia__image-frame">
              <img
                src="https://nexora-image.s3.ap-south-1.amazonaws.com/zoho+ads+page/One+Partner.+Multiple+Solutions.-new.webp"
                alt="One partner coordinating multiple clinic solutions"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>

      <section
        className="who-we-support"
        aria-labelledby="who-we-support-title"
      >
        <div className="who-we-support__container">
          <header className="who-we-support__header">
            <p className="who-we-support__eyebrow">WHO WE SUPPORT</p>

            <h2 id="who-we-support-title" className="who-we-support__heading">
              Built for Every Stage of Clinic Ownership
            </h2>
          </header>

          <div className="who-we-support__cards">
            {audiences.map((audience) => (
              <article className="who-we-support__card" key={audience.title}>
                <div className="who-we-support__card-content">
                  <div className="who-we-support__card-heading">
                    <span className="who-we-support__icon">
                      <AudienceIcon type={audience.icon} />
                    </span>

                    <h3 className="who-we-support__card-title">
                      {audience.title}
                    </h3>
                  </div>

                  <p className="who-we-support__card-description">
                    {audience.description}
                  </p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="start-journey" aria-labelledby="start-journey-title">
        <div className="start-journey__container">
          <div className="start-journey__main">
            <div className="start-journey__content">
              <h2 id="start-journey-title" className="start-journey__title">
                START YOUR CLINIC JOURNEY WITH ELUMIA
              </h2>

              <p className="start-journey__description">
                Whether you are still developing the concept or already
                preparing your facility, our team can help identify the next
                steps.
              </p>

              <div className="start-journey__brief">
                <h3 className="start-journey__brief-title">
                  Book an Initial Consultation — Tell us:
                </h3>

                <ul className="start-journey__details">
                  {consultationDetails.map((detail) => (
                    <li className="start-journey__detail" key={detail}>
                      <span
                        className="start-journey__detail-mark"
                        aria-hidden="true"
                      />
                      <span>{detail}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="start-journey__visual">
              <ImagePlaceholder
                className="start-journey__image--primary"
                image={primaryImage}
                alt="Clinic planning and consultation"
              />

              <ImagePlaceholder
                className="start-journey__image--secondary"
                image={secondaryImage}
                alt="Healthcare facility planning"
              />
            </div>
          </div>

          <div className="start-journey__cta">
            <p className="start-journey__cta-title">
              Ready to take the next step?
            </p>

            <div className="start-journey__cta-actions">
              <a className="start-journey__button" href={consultationUrl}>
                BOOK A CONSULTATION
                <span aria-hidden="true">↗</span>
              </a>

              <a
                className="start-journey__website"
                href="https://elumiamedstore.com/"
              >
                elumiamedstore.com
              </a>
            </div>
          </div>
        </div>
      </section>

      <section
        className="elumia-closing"
        aria-labelledby="elumia-closing-title"
      >
        <div className="elumia-closing__container">
          <div className="elumia-closing__content">
            <span className="elumia-closing__accent" aria-hidden="true" />

            <h2 id="elumia-closing-title" className="elumia-closing__title">
              Elumia Medstore
            </h2>

            <p className="elumia-closing__services">
              Medical Procurement | Clinic Setup | Digital | Regulatory Guidance
              {" | "}Recruitment &amp; Training
            </p>

            <h3 className="elumia-closing__statement">
              From Concept to Clinic.
              <br />
              From Clinic to Growth.
            </h3>
          </div>

          <div className="elumia-closing__visual">
            <div className="elumia-closing__image-frame">
              {imageSrc ? (
                <img
                  className="elumia-closing__image"
                  src={imageSrc}
                  alt="Elumia clinic environment"
                />
              ) : (
                <div
                  className="elumia-closing__placeholder"
                  role="img"
                  aria-label="Placeholder for Elumia clinic image"
                >
                  <svg
                    width="48"
                    height="48"
                    viewBox="0 0 48 48"
                    fill="none"
                    aria-hidden="true"
                  >
                    <rect
                      x="5"
                      y="8"
                      width="38"
                      height="32"
                      rx="5"
                      stroke="currentColor"
                      strokeWidth="2"
                    />
                    <circle
                      cx="17"
                      cy="19"
                      r="3"
                      stroke="currentColor"
                      strokeWidth="2"
                    />
                    <path
                      d="m8 35 11-10 7 6 6-5 8 9"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>

                  <span>Image Placeholder</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default ClinicalPlannersConsultants;
